import { gql } from "@apollo/client";

const GET_LOGIN_METHOD = gql`
  query GetLoginMethod($email: String!) {
    getLoginMethod(email: $email) {
      success
      hasPassword
      loginMethod
      error
    }
  }
`;

export default GET_LOGIN_METHOD;
